import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { CONTRACTORS_CRUD_ACTION_CREATORS } from '../actions/contractors_private_network_actions';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

// private_network/supplier_supplier_relationships
export const ContractorPrivateNetworksRestCrudThunksForBuyer = new RestCrudThunks(
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	CONTRACTORS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'private_network/'
);
export const ContractorPrivateNetworksRestCrudThunksForSupplier = new RestCrudThunks(
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	CONTRACTORS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'private_network/'
);

export const deleteSupplierSupplierRelationshipBySupplierFacilityId =
	(roleType) => (supplierFacilityId) => {
		const apiUrl = `/api/v1/${roleType}/private_network/supplier_supplier_relationships/delete_by_supplier/${supplierFacilityId}`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.delete(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

// Invites the primary contact of a subcontractor we just added to our private network.
// This is the supplier-supplier equivalent of `inviteSupplierUserFromBuyer` — the buyer-side
// spend_category endpoint invites against a buyer's supplier private network, which is the wrong
// relationship for a subcontractor and sends the invitee the wrong onboarding context.
export const inviteSubcontractorUser =
	(roleType) => (supplierFacilityId, fromEmail, toEmail, firstName, lastName) => {
		const apiUrl =
			`/api/v1/${roleType}/private_network/supplier_supplier_relationships/${supplierFacilityId}` +
			`/invite/${encodeURIComponent(fromEmail)}/${encodeURIComponent(toEmail)}` +
			`/name/${encodeURIComponent(firstName)}/${encodeURIComponent(lastName)}`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.post(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: {},
					})
					.then(parseJSON)
					.then(({ json, status }) => {
						const response = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (response.status === 'error') {
							reject(response.message);
						} else {
							resolve(response.data);
						}
					})
					.catch((error) => {
						reject(error.message);
					});
			});
		};
	};
